// Job Types
export const JOB_TYPES = {
  W2: 'W-2',
  CONTRACTOR_1099: '1099',
  C2C: 'C2C'
};

// Job Statuses
export const JOB_STATUSES = {
  WAITING: 'waiting',
  COMPLETED: 'completed',
  REJECTED: 'rejected'
};

// Interview Types
export const INTERVIEW_TYPES = {
  TECHNICAL: 'Technical',
  HR: 'HR',
  MANAGERIAL: 'Managerial',
  FINAL: 'Final',
  PHONE_SCREENING: 'Phone Screening'
};

// Interview Statuses
export const INTERVIEW_STATUSES = {
  WAITING: 'waiting',
  CONVERTED: 'converted',
  REJECTED: 'rejected'
};

// BD Names (Business Development representatives)
export const BD_NAMES = ['Ali', 'Moazzam', 'Awais'];

// Interview Rounds - Dynamic based on data
export const INTERVIEW_ROUNDS = []; // Will be populated dynamically

// Colors
export const STATUS_COLORS = {
  converted: '#28a745',
  rejected: '#dc3545',
  scheduled: '#007bff',
  completed: '#6f42c1',
  waiting: '#ffc107'
};

export const JOB_COLORS = ['#62D196', '#007bff', '#28a745', '#ffc107', '#dc3545', '#6f42c1'];

// Google Calendar (moved to environment variables)
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

// API Base URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Application Configuration
export const APP_NAME = process.env.REACT_APP_APP_NAME || 'Dex Interview Manager';
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';

